import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import RowGrid from "../atoms/RowGrid"
import GridWrapper from "../atoms/GridWrapper"
import Line from "../atoms/Line"
import { withStyles } from "@material-ui/core/styles"
import { mediumStyles } from "../constants"

const TextGrid = styled(Grid)(
  {
    textAlign: "left",
  },
  props => ({
    width: props.isMobile ? 350 : 700,
    padding: props.isMobile ? "30px 20px" : "30px 60px",
  })
)

const Title = styled.span({
  color: "#300",
  fontSize: "30px",
  fontFamily: "Avenir Next",
  display: "block",
  textAlign: "center",
})

const BaseGrid = styled(Grid)(
  {
    background: "white",
    margin: 20,
  },
  props => ({
    width: props.isMobile ? 350 : 700,
  })
)

const SubText = styled.span({
  fontSize: "13px",
  fontFamily: "Avenir Next",
  display: "block",
  textAlign: "center",
})

class ContentCard extends Component {
  render() {
    const { name, children, images, classes } = this.props
    return (
      <>
        <BaseGrid className={classes.pc}>
          <GridWrapper style={{ padding: "30px" }}>
            <Grid>
              <Title>{name}</Title>
              <Line width={700} />
              <TextGrid>{children}</TextGrid>
              {images ? (
                <RowGrid>
                  {images.map((image, i) => (
                    <Grid style={{ padding: "20px" }}>
                      <img src={image.src} style={{ maxHeight: "200px" }} />
                      {image.text ? <SubText>{image.text}</SubText> : null}
                    </Grid>
                  ))}
                </RowGrid>
              ) : null}
            </Grid>
          </GridWrapper>
        </BaseGrid>
        <BaseGrid isMobile className={classes.mobile}>
          <GridWrapper style={{ padding: "30px 10px" }}>
            <Grid>
              <Title>{name}</Title>
              <Line width={300} />
              <TextGrid isMobile>{children}</TextGrid>
              {images ? (
                <RowGrid>
                  {images.map((image, i) => (
                    <Grid style={{ padding: "20px" }}>
                      <img src={image.src} style={{ maxHeight: "200px" }} />
                      {image.text ? <SubText>{image.text}</SubText> : null}
                    </Grid>
                  ))}
                </RowGrid>
              ) : null}
            </Grid>
          </GridWrapper>
        </BaseGrid>
      </>
    )
  }
}

export default withStyles(mediumStyles)(ContentCard)
